import {createFileRoute} from '@tanstack/react-router'
import RyderCupList from "../../../rydercup/RyderCupList.tsx";

export const Route = createFileRoute('/_app/rydercup/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <RyderCupList />
}
